module.exports = __webpack_public_path__ + "static/media/d.aa902e9c.png";